import React, { useState, useEffect } from "react";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Chip from "@mui/material/Chip";
import Avatar from "@mui/material/Avatar";
import Stack from "@mui/material/Stack";
import SettingsVoiceIcon from "@mui/icons-material/SettingsVoice";
import CreateIcon from "@mui/icons-material/Create";
import { green } from "@mui/material/colors";
import Divider from "@mui/material/Divider";
import AscencionsTabs from "../components/AscencionsTabs";
import { BoxLoading } from "react-loadingg";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import TableHead from "@mui/material/TableHead";
const CharacterDetail = ({ match }) => {
  const idSearch = match.params.id;

  const [character, setCharacter] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      const res = await fetch(
        `https://revived-witch-api.herokuapp.com/api/characters/${idSearch}`
      );
      res.json().then((res) => setCharacter(res.character));
    };

    fetchData();
  }, [idSearch]);

  return (
    <div>
      {character?.length === 0 || null ? (
        <div style={{ height: "100vh", weight: "50%" }}>
          <BoxLoading />
        </div>
      ) : (
        <>
          <Grid
            container
            spacing={2}
            style={{ marginTop: 30, marginBottom: 30 }}
          >
            <Grid item xs={12} md={12}>
              {character.name.length > 6 ? (
                <Typography
                  variant="h4"
                  style={{
                    textAlign: "center",
                    fontStyle: "italic",
                  }}
                >
                  {character.name}
                </Typography>
              ) : (
                <Typography
                  variant="h2"
                  style={{
                    textAlign: "center",
                    fontStyle: "italic",
                  }}
                >
                  {character.name}
                </Typography>
              )}
            </Grid>
            <Grid item xs={12} md={12}>
              <Typography
                variant="h4"
                style={{
                  background: "linear-gradient(to right,#00f260, #0575e6)",
                  borderRadius: 30,
                  color: "white",
                  textAlign: "center",
                  fontStyle: "italic",
                }}
              >
                {character.sub_title}
              </Typography>
            </Grid>
          </Grid>
          <Grid container spacing={2}>
            <Grid item xs={12} md={4}>
              <Card variant="outlined" style={{ borderRadius: 25 }}>
                <CardContent>
                  <Stack
                    direction="column"
                    spacing={2}
                    justifyContent="flex-start"
                    alignItems="flex-start"
                  >
                    <Stack
                      direction="row"
                      spacing={2}
                      justifyContent="center"
                      alignItems="center"
                    >
                      <Avatar
                        style={{ width: 60, height: 60 }}
                        variant="square"
                        alt="rarityIcons"
                        src={character.clas.icon}
                        sx={{ width: 60, height: 60 }}
                      />
                      <Typography variant="h5">
                        {character.clas.name}
                      </Typography>
                    </Stack>
                    <Stack
                      direction="row"
                      spacing={2}
                      justifyContent="center"
                      alignItems="center"
                    >
                      <Avatar
                        style={{ width: 60, height: 60 }}
                        variant="square"
                        alt="rarityIcons"
                        src={character.type.icon}
                        sx={{ width: 60, height: 60 }}
                      />
                      <Typography variant="h5">
                        {character.type.name}
                      </Typography>
                    </Stack>
                    <Stack
                      direction="row"
                      spacing={2}
                      justifyContent="center"
                      alignItems="center"
                    >
                      <Avatar
                        sx={{ width: 60, height: 60, bgcolor: green[500] }}
                      >
                        <SettingsVoiceIcon />
                      </Avatar>
                      <Typography variant="h5">{character.cv}</Typography>
                    </Stack>
                    <Stack
                      direction="row"
                      spacing={2}
                      justifyContent="center"
                      alignItems="center"
                    >
                      <Avatar
                        sx={{ width: 60, height: 60, bgcolor: green[500] }}
                      >
                        <CreateIcon />
                      </Avatar>
                      <Typography variant="h5">{character.artist}</Typography>
                    </Stack>
                  </Stack>
                </CardContent>
              </Card>
              <Card
                style={{ marginTop: 15, borderRadius: 25 }}
                variant="outlined"
              >
                <CardContent>
                  <Typography
                    variant="h3"
                    style={{ textAlign: "center", marginBottom: 10 }}
                  >
                    Profile
                  </Typography>

                  <Divider style={{ marginBottom: 15 }}>
                    <Chip label="AFILIATION" color="primary" />
                  </Divider>
                  <Stack
                    direction="row"
                    spacing={2}
                    justifyContent="flex-start"
                    alignItems="center"
                  >
                    <Avatar
                      style={{ width: 60, height: 60 }}
                      variant="square"
                      alt="rarityIcons"
                      src={character.afiliation.icon}
                      sx={{
                        width: 60,
                        height: 60,
                        backgroundColor: "black",
                        borderRadius: "8px",
                      }}
                    />
                    <Typography variant="h5">
                      {character.afiliation.name}
                    </Typography>
                  </Stack>

                  <Divider style={{ marginTop: 30, marginBottom: 30 }}>
                    <Chip label="DETAILS" color="info" />
                  </Divider>
                  <Stack
                    direction="column"
                    spacing={2}
                    justifyContent="flex-start"
                    alignItems="flex-start"
                  >
                    <Typography variant="h5">
                      Gender : {character.gender}
                    </Typography>
                    <Typography variant="h5">Age : {character.age} </Typography>
                    <Typography variant="h5">
                      Birthday : {character.birthday}
                    </Typography>
                    <Typography variant="h5">
                      Weight : {character.weight}
                    </Typography>
                    <Typography variant="h5">
                      Height : {character.height}
                    </Typography>
                    <Typography variant="h5">
                      Hobbys : {character.hobby}
                    </Typography>
                  </Stack>
                </CardContent>
              </Card>
              <Card
                style={{ marginTop: 15, borderRadius: 30 }}
                variant="outlined"
              >
                <CardContent>
                  <Divider style={{ marginBottom: 20 }}>
                    <Chip label="EVOLUTIONS" color="error" />
                  </Divider>
                  <Stack
                    direction="column"
                    spacing={2}
                    justifyContent="flex-start"
                    alignItems="flex-start"
                  >
                    <Typography variant="h5">
                      Evo.1 : {character.evolutions.first}
                    </Typography>

                    <Typography variant="h5">
                      Evo.2 : {character.evolutions.second}
                    </Typography>
                    <Typography variant="h5">
                      Evo.3 : {character.evolutions.third}
                    </Typography>
                  </Stack>
                </CardContent>
              </Card>
            </Grid>

            <Grid item xs={12} md={8}>
              <AscencionsTabs data={character.imageFullRes} />
              <Divider style={{ marginBottom: 20 }}>
                <Chip
                  label="ATTRIBUTES (AC1 Lv.1 to AC4 Lv.90)"
                  color="secondary"
                />
              </Divider>
              <TableContainer component={Paper}>
                <Table sx={{ minWidth: 650 }} aria-label="simple table">
                  <TableBody>
                    <TableRow
                      key="a"
                      sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                    >
                      <TableCell component="th" scope="row">
                        <Stack
                          direction="row"
                          justifyContent="flex-start"
                          alignItems="center"
                          spacing={2}
                        >
                          <Avatar
                            style={{
                              width: 50,
                              height: 40,
                              borderRadius: "5px",
                            }}
                            variant="square"
                            alt="rarityIcons"
                            src="https://res.cloudinary.com/dt8txlhs2/image/upload/v1637386231/RevivedWitch/physicIcon_xfm7lh.png"
                          />
                          <Typography variant="h6">ATK</Typography>
                        </Stack>
                      </TableCell>
                      <TableCell align="right">
                        {character.attributes.atk}
                      </TableCell>
                      <TableCell align="right">
                        <Stack
                          direction="row"
                          justifyContent="flex-start"
                          alignItems="center"
                          spacing={2}
                        >
                          <Avatar
                            style={{
                              width: 50,
                              height: 40,
                              borderRadius: "5px",
                            }}
                            variant="square"
                            alt="rarityIcons"
                            src="https://res.cloudinary.com/dt8txlhs2/image/upload/v1637386231/RevivedWitch/healthIcons_g6dcnx.png"
                          />
                          <Typography variant="h6">HP</Typography>
                        </Stack>
                      </TableCell>
                      <TableCell align="right">
                        {character.attributes.hp}
                      </TableCell>
                    </TableRow>
                    <TableRow
                      key="b"
                      sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                    >
                      <TableCell component="th" scope="row">
                        <Stack
                          direction="row"
                          justifyContent="flex-start"
                          alignItems="center"
                          spacing={2}
                        >
                          <Avatar
                            style={{
                              width: 50,
                              height: 40,
                              borderRadius: "5px",
                            }}
                            variant="square"
                            alt="rarityIcons"
                            src="https://res.cloudinary.com/dt8txlhs2/image/upload/v1637449382/RevivedWitch/physicResIcon_cwopph.png"
                          />
                          <Typography variant="h6">PHYSICAL DEF</Typography>
                        </Stack>
                      </TableCell>
                      <TableCell align="right">
                        {character.attributes.physicalDef}
                      </TableCell>
                      <TableCell align="right">
                        <Stack
                          direction="row"
                          justifyContent="flex-start"
                          alignItems="center"
                          spacing={2}
                        >
                          <Avatar
                            style={{
                              width: 50,
                              height: 40,
                              borderRadius: "5px",
                            }}
                            variant="square"
                            alt="rarityIcons"
                            src="https://res.cloudinary.com/dt8txlhs2/image/upload/v1637449382/RevivedWitch/magicResIcon_xeyfaf.png"
                          />
                          <Typography variant="h6">MAGIC DEF</Typography>
                        </Stack>
                      </TableCell>
                      <TableCell align="right">
                        {character.attributes.magicDef}
                      </TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>
            </Grid>
          </Grid>
          <Divider style={{ marginTop: 30 }}>
            <Chip label="SKILLS" color="warning" size="medium" />
          </Divider>
          <Grid container spacing={2} style={{ marginTop: 30 }}>
            <Grid item xs={12} md={4} style={{ display: "flex" }}>
              <Card
                variant="outlined"
                style={{ height: "100%", borderRadius: 25 }}
              >
                <Stack
                  direction="row"
                  spacing={2}
                  justifyContent="center"
                  alignItems="center"
                >
                  <img
                    style={{ width: 135, height: 120, borderRadius: 10 }}
                    alt="rarityIcons"
                    src={character.skills[0].icon}
                  />
                </Stack>
                <CardContent>
                  <Typography gutterBottom variant="h5" component="div">
                    {character.skills[0].name}
                  </Typography>
                  <Stack
                    direction="row"
                    spacing={2}
                    justifyContent="center"
                    alignItems="center"
                  >
                    <Chip
                      label={character.skills[0].atk_type}
                      color="success"
                      variant="h2"
                    />
                    <Chip
                      label={character.skills[0].enemy_count}
                      color="success"
                      variant="h2"
                    />
                  </Stack>
                  <Typography
                    style={{ marginTop: 5, marginBottom: 5 }}
                  ></Typography>
                  {/*SKILL COST START*/}
                  {character.skills[0].energy.type === "cost" ? (
                    <>
                      <Stack
                        direction="row"
                        spacing={2}
                        justifyContent="center"
                        alignItems="center"
                      >
                        <Typography>Cost : </Typography>
                        <Stack
                          direction="row"
                          spacing={2}
                          justifyContent="center"
                          alignItems="center"
                        >
                          <Avatar
                            style={{
                              width: 40,
                              height: 30,
                              borderRadius: "5px",
                            }}
                            variant="square"
                            alt="rarityIcons"
                            src="https://res.cloudinary.com/dt8txlhs2/image/upload/v1637694401/RevivedWitch/order_grwnuz.png"
                          />
                          <Typography>
                            {character.skills[0].energy.order}
                          </Typography>
                        </Stack>
                        <Stack
                          direction="row"
                          spacing={2}
                          justifyContent="center"
                          alignItems="center"
                        >
                          <Avatar
                            style={{
                              width: 40,
                              height: 30,
                              borderRadius: "5px",
                            }}
                            variant="square"
                            alt="rarityIcons"
                            src="https://res.cloudinary.com/dt8txlhs2/image/upload/v1637694401/RevivedWitch/chaos_joc9fo.png"
                          />
                          <Typography>
                            {character.skills[0].energy.chaos}
                          </Typography>
                        </Stack>
                      </Stack>
                    </>
                  ) : (
                    <>
                      <Stack
                        direction="row"
                        spacing={0}
                        justifyContent="center"
                        alignItems="center"
                      >
                        <Typography>Charge : </Typography>
                        <Stack
                          direction="row"
                          spacing={2}
                          justifyContent="center"
                          alignItems="center"
                        >
                          <Avatar
                            style={{
                              width: 40,
                              height: 30,
                              borderRadius: "5px",
                            }}
                            variant="square"
                            alt="rarityIcons"
                            src="https://res.cloudinary.com/dt8txlhs2/image/upload/v1637694401/RevivedWitch/charge_k8wxp8.png"
                          />
                          <Avatar
                            style={{
                              width: 40,
                              height: 30,
                              borderRadius: "5px",
                            }}
                            variant="square"
                            alt="rarityIcons"
                            src="https://res.cloudinary.com/dt8txlhs2/image/upload/v1637694401/RevivedWitch/charge_k8wxp8.png"
                          />
                          <Avatar
                            style={{
                              width: 40,
                              height: 30,
                              borderRadius: "5px",
                            }}
                            variant="square"
                            alt="rarityIcons"
                            src="https://res.cloudinary.com/dt8txlhs2/image/upload/v1637694401/RevivedWitch/charge_k8wxp8.png"
                          />
                          <Avatar
                            style={{
                              width: 40,
                              height: 30,
                              borderRadius: "5px",
                            }}
                            variant="square"
                            alt="rarityIcons"
                            src="https://res.cloudinary.com/dt8txlhs2/image/upload/v1637694401/RevivedWitch/charge_k8wxp8.png"
                          />
                        </Stack>
                      </Stack>
                    </>
                  )}

                  {/*SKILL COST END*/}
                  <Typography
                    variant="body2"
                    color="text.secondary"
                    style={{ marginTop: 10, borderRadius: 10 }}
                  >
                    {character.skills[0].description}
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
            <Grid item xs={12} md={4}>
              <Card
                variant="outlined"
                style={{ height: "100%", borderRadius: 25 }}
              >
                <Stack
                  direction="row"
                  spacing={2}
                  justifyContent="center"
                  alignItems="center"
                >
                  <img
                    style={{ width: 135, height: 120, borderRadius: 10 }}
                    alt="rarityIcons"
                    src={character.skills[1].icon}
                  />
                </Stack>

                <CardContent>
                  <Typography gutterBottom variant="h5" component="div">
                    {character.skills[1].name}
                  </Typography>
                  <Stack
                    direction="row"
                    spacing={2}
                    justifyContent="center"
                    alignItems="center"
                  >
                    <Chip
                      label={character.skills[1].atk_type}
                      color="success"
                      variant="h2"
                    />
                    <Chip
                      label={character.skills[1].enemy_count}
                      color="success"
                      variant="h2"
                    />
                  </Stack>
                  <Typography
                    style={{ marginTop: 5, marginBottom: 5 }}
                  ></Typography>
                  {/*SKILL COST START*/}
                  {character.skills[1].energy.type === "cost" ? (
                    <>
                      <Stack
                        direction="row"
                        spacing={2}
                        justifyContent="center"
                        alignItems="center"
                      >
                        <Typography>Cost : </Typography>
                        <Stack
                          direction="row"
                          spacing={2}
                          justifyContent="center"
                          alignItems="center"
                        >
                          <Avatar
                            style={{
                              width: 40,
                              height: 30,
                              borderRadius: "5px",
                            }}
                            variant="square"
                            alt="rarityIcons"
                            src="https://res.cloudinary.com/dt8txlhs2/image/upload/v1637694401/RevivedWitch/order_grwnuz.png"
                          />
                          <Typography>
                            {character.skills[1].energy.order}
                          </Typography>
                        </Stack>
                        <Stack
                          direction="row"
                          spacing={2}
                          justifyContent="center"
                          alignItems="center"
                        >
                          <Avatar
                            style={{
                              width: 40,
                              height: 30,
                              borderRadius: "5px",
                            }}
                            variant="square"
                            alt="rarityIcons"
                            src="https://res.cloudinary.com/dt8txlhs2/image/upload/v1637694401/RevivedWitch/chaos_joc9fo.png"
                          />
                          <Typography>
                            {character.skills[1].energy.chaos}
                          </Typography>
                        </Stack>
                      </Stack>
                    </>
                  ) : (
                    <>
                      <Stack
                        direction="row"
                        spacing={0}
                        justifyContent="center"
                        alignItems="center"
                      >
                        <Typography>Charge : </Typography>
                        <Stack
                          direction="row"
                          spacing={2}
                          justifyContent="center"
                          alignItems="center"
                        >
                          <Avatar
                            style={{
                              width: 40,
                              height: 30,
                              borderRadius: "5px",
                            }}
                            variant="square"
                            alt="rarityIcons"
                            src="https://res.cloudinary.com/dt8txlhs2/image/upload/v1637694401/RevivedWitch/charge_k8wxp8.png"
                          />
                          <Avatar
                            style={{
                              width: 40,
                              height: 30,
                              borderRadius: "5px",
                            }}
                            variant="square"
                            alt="rarityIcons"
                            src="https://res.cloudinary.com/dt8txlhs2/image/upload/v1637694401/RevivedWitch/charge_k8wxp8.png"
                          />
                          <Avatar
                            style={{
                              width: 40,
                              height: 30,
                              borderRadius: "5px",
                            }}
                            variant="square"
                            alt="rarityIcons"
                            src="https://res.cloudinary.com/dt8txlhs2/image/upload/v1637694401/RevivedWitch/charge_k8wxp8.png"
                          />
                          <Avatar
                            style={{
                              width: 40,
                              height: 30,
                              borderRadius: "5px",
                            }}
                            variant="square"
                            alt="rarityIcons"
                            src="https://res.cloudinary.com/dt8txlhs2/image/upload/v1637694401/RevivedWitch/charge_k8wxp8.png"
                          />
                        </Stack>
                      </Stack>
                    </>
                  )}

                  {/*SKILL COST END*/}
                  <Typography
                    variant="body2"
                    color="text.secondary"
                    style={{ marginTop: 10 }}
                  >
                    {character.skills[1].description}
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
            <Grid item xs={12} md={4}>
              <Card
                variant="outlined"
                style={{ height: "100%", borderRadius: 25 }}
              >
                <Stack
                  direction="row"
                  spacing={2}
                  justifyContent="center"
                  alignItems="center"
                >
                  <img
                    style={{ width: 135, height: 120 }}
                    alt="rarityIcons"
                    src={character.skills[2].icon}
                  />
                </Stack>
                <CardContent>
                  <Typography gutterBottom variant="h5" component="div">
                    {character.skills[2].name}
                  </Typography>
                  <Chip
                    label={character.skills[2].atk_type}
                    color="success"
                    variant="h2"
                  />
                  <Typography
                    variant="body2"
                    color="text.secondary"
                    style={{ marginTop: 10 }}
                  >
                    {character.skills[2].description}
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          </Grid>
          <Divider style={{ marginTop: 20 }}>
            <Chip label="ASCENCIONS DATA" color="error" />
          </Divider>
          <Grid
            container
            spacing={2}
            style={{ marginTop: 30, marginBottom: 30 }}
          >
            <Grid item xs={12} md={12}>
              <TableContainer component={Paper} variant="outlined">
                <Table sx={{ minWidth: 650 }} aria-label="simple table">
                  <TableHead>
                    <TableRow>
                      <TableCell>Ascension</TableCell>
                      <TableCell align="right">HP</TableCell>
                      <TableCell align="right">Physical ATK</TableCell>
                      <TableCell align="right">Physical DEF</TableCell>
                      <TableCell align="right">Magic DEF</TableCell>
                      <TableCell align="right">Materials Needed</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {character.acInfo?.map((ac, index) => (
                      <>
                        <TableRow
                          key={index}
                          sx={{
                            "&:last-child td, &:last-child th": { border: 0 },
                          }}
                        >
                          <TableCell component="th" scope="row">
                            {index + 1}
                          </TableCell>
                          <TableCell align="right">{ac.hp}</TableCell>
                          <TableCell align="right">{ac.atk}</TableCell>
                          <TableCell align="right">{ac.phyRes}</TableCell>
                          <TableCell align="right">{ac.magicRes}</TableCell>
                          <TableCell align="right">
                            {ac.itemsNedeed?.map((it) => (
                              <Stack
                                direction="row"
                                justifyContent="flex-start"
                                alignItems="center"
                                spacing={2}
                                style={{ marginBottom: 10 }}
                              >
                                <Avatar
                                  style={{
                                    width: 60,
                                    height: 50,
                                    borderRadius: "5px",
                                  }}
                                  variant="square"
                                  alt="rarityIcons"
                                  src={it.item.icon}
                                />
                                <Typography variant="body1">
                                  {it.item.name}
                                </Typography>
                                <Typography variant="body1">
                                  x{it.qty}
                                </Typography>
                              </Stack>
                            ))}
                          </TableCell>
                        </TableRow>
                      </>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Grid>
            <Grid item xs={12} md={12}>
              <Divider style={{ marginTop: 20 }}>
                <Chip label="SKILLS UPGRADE COST" color="warning" />
              </Divider>
            </Grid>
          </Grid>
        </>
      )}
    </div>
  );
};

export default CharacterDetail;
